<template>
    <div class="tile">
        <div class="tile-title">
            <h2>Additional Information</h2>
        </div>
        <div class="tile-content">
            <ul class="list">
                <li class="list-item">
                    <span class="text-muted inline-s">Acquirer</span>{{gateway.acquirerName}}
                </li>
                <li class="list-item">
                    <span class="text-muted inline-s">Merchant Category Code</span>{{gateway.merchantCategoryCode}}
                </li>
                <li class="list-item">
                    <span class="text-muted inline-s">Sticky Gateway Account</span>{{sticky}}
                </li>
                <li class="list-item" v-if="gateway.timeout">
                    <span class="text-muted inline-s">Gateway Account Timeout</span>{{gateway.timeout}}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import detailsMixins from './details-mixins';

    export default {
        name: 'additional-information',
        mixins: [detailsMixins],

        computed: {
            sticky() {
                return this.gateway.sticky ? 'Enabled' : 'Disabled';
            },
        },
    };
</script>
